import { defineStore } from 'pinia';
import { getUploader } from '@nextcloud/upload';
let uploader;
export const useUploaderStore = function (...args) {
    // Only init on runtime
    uploader = getUploader();
    const store = defineStore('uploader', {
        state: () => ({
            queue: uploader.queue,
        }),
    });
    return store(...args);
};
